import { Reducer } from 'umi';

const namespace = 'opinionMarketingFilter';

type IStateType = {
  [instanceId: string]: any; // 每个实例的状态
};

const customModel: {
  namespace: string;
  state: IStateType;
  reducers: {
    UPDATE_FILTER: Reducer<IStateType>;
    INIT_FILTER: Reducer<IStateType>;
    RESET_FILTER: Reducer<IStateType>;
  };
} = {
  namespace,
  state: {},
  reducers: {
    UPDATE_FILTER(state: IStateType, { payload, instanceId = 'default' }) {
      return {
        ...state,
        [instanceId]: {
          ...(state[instanceId] || {}),
          ...payload,
        },
      };
    },
    INIT_FILTER(state: IStateType, { payload, instanceId = 'default' }) {
      return {
        ...state,
        [instanceId]: payload,
      };
    },
    RESET_FILTER(state: IStateType, { payload, instanceId = 'default' }) {
      return {
        ...state,
        [instanceId]: {
          ...(state[instanceId] || {}),
          ...payload,
        },
      };
    },
  },
};

export default customModel;
